import { Question } from 'types'

export const deleteQuestion = (
  questions: Question[],
  theQuestion: Question
): Question[] => questions.filter(questionItem => questionItem.id !== theQuestion.id)
